import Base from "@/api/Base";

export default class Resend extends Base
{
	setCustomerId (v)
	{
		this.data.customerId = v;
		return this;
	}

	setType (v)
	{
		this.data.type = v;
		return this;
	}

	getMethod ()
	{
		return 'POST';
	}

	getUrl ()
	{
		return '/kunde/legitimierung/erneut-senden';
	}
}